import React, { FC, SVGProps } from 'react'
import SVGUniqueID from 'react-svg-unique-id'

interface BlurLineBreakIconProps extends SVGProps<SVGSVGElement> {
  width?: string
  height?: number
}

const BlurLineBreakIcon: FC<BlurLineBreakIconProps> = ({
  width = '100%',
  height = 3
}) => (
  <SVGUniqueID>
    <svg
      width={width}
      height={height}
      viewBox="0 0 286 2"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M0 0.799805H286" stroke="url(#paint0_radial_123_8484)" />
      <defs>
        <radialGradient
          id="paint0_radial_123_8484"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(143 1.2998) rotate(90) scale(0.5 143)"
        >
          <stop stopColor="#1E5DFF" />
          <stop offset={1} stopOpacity={0} />
        </radialGradient>
      </defs>
    </svg>
  </SVGUniqueID>
)

export { BlurLineBreakIcon }
